import { InboxOutlined } from '@ant-design/icons'
import type { UploadFile, UploadProps } from 'antd'
import { Flex, List, message, notification, Upload } from 'antd'
import { UploadChangeParam } from 'antd/es/upload'
import { useState } from 'react'
import { Song } from '../../../utils/redux/songsSlice'
import { useAppSelector } from '../../../utils/redux/store'

const { Dragger } = Upload

function UploadTracks() {
  const { token } = useAppSelector((state) => state.auth)
  const [uploadedFiles, setUploadedFiles] = useState<UploadFile<Song>[]>([])
  const [failedFiles, setFailedFiles] = useState<UploadFile<Song>[]>([])

  async function onUploaded(info: UploadChangeParam<UploadFile<Song>>) {
    message.success(`${info.file.response?.title} has been successfully failed!`)
  }

  const draggerProps: UploadProps = {
    showUploadList: false,
    name: 'file',
    multiple: true,
    accept: '.mp3',
    // maxCount: 20,
    action: `${process.env.REACT_APP_API_BASE_URL}/song/upload`,
    onChange: (info) => {
      if (info.file.status === 'uploading') {
        // setIsUploading(true)
      } else if (info.file.status === 'done') {
        setUploadedFiles((prev) => [...prev, info.file])
        onUploaded(info)
      } else if (info.file.status === 'error') {
        setFailedFiles((prev) => [...prev, info.file])
        if (info.file.response.statusCode === 401)
          notification.error({
            message: `Your session has expired, please re login and try again`,
          })
        else
          notification.error({
            message: `Could not upload ${info.file.name} file at this moment`,
          }) //TODO: add variable to translation
      }

      // setIsUploading(false)
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  return (
    <Flex vertical gap={20}>
      <Dragger {...draggerProps}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag files to this area to upload</p>
        <p className="ant-upload-hint">use .mp3 format only</p>
      </Dragger>
      <List
        header={<div>Failed tracks</div>}
        bordered
        dataSource={failedFiles}
        renderItem={(item) => (
          <List.Item onClick={() => console.error('failed item:', item)}>
            <List.Item.Meta
              title={item.response?.title || item.name || item.fileName}
              description={item.response?.artist || item.error?.message}
            />
          </List.Item>
        )}
      />
      <List
        header={<div>Successfully uploaded tracks</div>}
        bordered
        dataSource={uploadedFiles}
        renderItem={(item) => (
          <List.Item /* onClick={() => console.log('item:', item)} */>
            <List.Item.Meta
              title={item.response?.title}
              description={item.response?.artist}
            />
          </List.Item>
        )}
      />
    </Flex>
  )
}

export default UploadTracks
